import DebouncedFunction from './DebouncedFunction';

class StickyController {
  /**
   * @param elements - a jQuery collection of elements
   */
  constructor(elements) {
    this.elements = elements;

    this.init();
    let self = this;

    new DebouncedFunction($(document), 'scroll.sticky', () => {
      self.checkStick();
    });
    new DebouncedFunction($(window), 'resize.sticky', () => {
      self._handleResize();
    });
    $(window).on('checksticky', () => {
      self._handleResize();
    });
  }

  /**
   * Initialise and re-calculate positions - this can be called manually
   */
  init() {
    this.elements.each(function() {
      let element = $(this);
      if (element.data('sticky.isStuck')) {
        StickyController.unstickElement(element);
      }
    });

    this._calculateTriggerPoints();
    this.windowWidth = $(window).width(); // Update cached window width value
    this.checkStick();
  }

  /**
   * Handle a window resize event - reinitialise
   * @private
   */
  _handleResize() {
    let self = this;
    window.clearTimeout(this.resizeTimer);
    this.resizeTimer = window.setTimeout(() => {
      self.init();
    }, 25);
  }

  /**
   * Calculate the points at which each element should "stick"
   * @private
   */
  _calculateTriggerPoints() {
    let htmlTop = $(document.documentElement).offset().top,
        previouslyStuckItemsOffset = 0;

    this.elements.each(function() {
      let element = $(this),
          scrollPoint = element.offset().top - htmlTop - previouslyStuckItemsOffset,
          stickOffset = previouslyStuckItemsOffset;

      if (element.data('stickyTrigger') === 'bottom') {
        scrollPoint += element.outerHeight();
      }

      if (element.data('stickyOffset')) {
        stickOffset += element.data('stickyOffset');
        scrollPoint -= element.data('stickyOffset');
      }

      if (element.data('stickyParentLimited')) {
        let bottomPosition = previouslyStuckItemsOffset + element.get(0).getBoundingClientRect().height;
        if (element.data('stickyOffset')) {
          bottomPosition += element.data('stickyOffset');
        }
        element.data('sticky.bottomPos', bottomPosition);
        element.data('sticky.parentBottomOffset', element.parent().offset().top + element.parent().outerHeight());
      }

      if (element.data('sticky.isStuck')) {
        if (element.attr('data-sticky-loner') === undefined) {
          previouslyStuckItemsOffset += element.outerHeight();
        }
      } else {
        element.data('sticky.scrollPoint', scrollPoint);
        element.data('sticky.stickOffset', stickOffset);
      }
    });
  }

  /**
   * Check whether each element should be stuck at the current scroll position
   */
  checkStick() {
    let self = this;
    let currentScrollY = (window.scrollY || window.pageYOffset);

    this.elements.each(function() {
      let element = $(this);
      if (
          (element.data('stickyMinWidth') && element.data('stickyMinWidth') > self.windowWidth)
          || (element.data('stickyMaxWidth') && element.data('stickyMaxWidth') <= self.windowWidth)
      ) {
        return;
      }

      if (currentScrollY >= element.data('sticky.scrollPoint')) {
        if (!element.data('sticky.isStuck')) {
          StickyController.stickElement(element);
          self._calculateTriggerPoints();
        }

        if (element.data('stickyParentLimited')) {
          if (element.data('sticky.bottomPos') >= (element.data('sticky.parentBottomOffset') - currentScrollY)) {
            element.addClass('js-is-stuck-bottom');
          } else {
            element.removeClass('js-is-stuck-bottom');
          }
        }
      } else if (element.data('sticky.isStuck')) {
        StickyController.unstickElement(element);
      }
    });
  }

  /**
   * Make the given element sticky
   * @param element
   */
  static stickElement(element) {
    let filler;
    // Elements can opt out of having a "filler" element added to replace them in the
    // document flow by adding a data-sticky-emulate-height="false" attribute
    if (element.data('stickyEmulateHeight') !== false) {
      filler = $('<div />');
      filler.height(element.outerHeight(true));
    }

    element.width(element.width()) // Forces pixel-width
        .css({
          'position': 'fixed',
          'top': element.data('sticky.stickOffset')
        })
        .addClass('js-is-stuck')
        .data('sticky.isStuck', true);

    if (filler) {
      // Store reference to filler element so we can remove it later if needed
      element.data('sticky.filler', filler)
          .after(filler);
    }
  }

  /**
   * Remove "stickiness" from the given element
   * @param element
   */
  static unstickElement(element) {
    element.css({
      'position': '',
      'top': '',
      'width': ''
    })
        .removeClass('js-is-stuck js-is-stuck-bottom')
        .data('sticky.isStuck', false);

    // If the element has a "filler", remove it
    if (element.data('sticky.filler')) {
      element.data('sticky.filler').remove();
    }
  }
}

export default StickyController;
